import {UyapRequest} from "./UyapRequest";

export interface GetKurumMersisAdresiTalep {
    mersisNo: any,
    vergiNo: any

}

export interface GetKurumMersisAdresiCevap {
    ilKodu: number,
    ilceKodu: number,
    adres: string,
    ilAdi: string,
    ilceAdi: string,
    ulkeKodu: number,
    adresTuru: string,
    resultCode: number
}

/** UYAP ekranı da il kodu 0 gelen cevabı "mersis adresi bulunamadı" sayıyor. */
export function mersisAdresiBulunduMu(cevap: any): boolean {
    return !!cevap && Number(cevap.resultCode) === 0 && Number(cevap.ilKodu) > 0 && String(cevap.adres || "").trim() != "";
}

export class GetKurumMersisAdresi extends UyapRequest<GetKurumMersisAdresiTalep, GetKurumMersisAdresiCevap> {
    delayTime = 0;

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Kurum MERSİS adresi getiriliyor...";
    }


    cache() {
        // DEV-3879: MTS toplu sorgusunda aynı şirket her satırda yeniden sorgulanmasın.
        // Evrak formları mersisNo'suz çağırıyor; onlarda önbellek kapalı kalır.
        let mersisNo = String(this.talepData?.mersisNo || "").trim();
        return {
            active: mersisNo != "",
            ttl: (60 * 24), //* 1 gun
            key: "GetKurumMersisAdresi_" + mersisNo + "_" + String(this.talepData?.vergiNo || "").trim()
        };
    }

    // DEV-3879: "Bulunamadı" cevabı önbelleğe yazılmasın; yoksa şirketin mersis adresi bir gün boyunca bulunamaz.
    protected onbellegeYazilabilirMi(cevap: any): boolean {
        return mersisAdresiBulunduMu(cevap);
    }

    getMockResponse(): any {
        return {
            "ilKodu": 6,
            "ilceKodu": 25,
            "adres": "Hacettepe-Ä°vedik Osb Teknokenti 1368. Cadde (Melih GÃ¶kÃ§ek BulvarÄ±) No: 61 3. Kat Ofis No: 15 Yenimahalle/ANKARA",
            "ilAdi": "ANKARA",
            "ilceAdi": "YENÄ°MAHALLE",
            "ulkeKodu": 0,
            "adresTuru": "ADRTR00011",
            "resultCode": 0
        };
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'get_kurum_mersis_adresi.ajx';
    }

    async parse(data: any): Promise<GetKurumMersisAdresiCevap> {
        return data;
    }

}

export default GetKurumMersisAdresi;
